import { FC, type Ref } from "react";

import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import CustomErrorMessage from "@/components/forms/inputsWithRef/customErrorMessage";

interface Props {
  id: any;
  label: any;
  control: any;
  name: any;
  required?: any;
  requiredErrorMessage?: any;
  style?: any;
  className?: string;
  errorWrapperStyle?: any;
  errorFontColor?: any;
  validationTargetRef?: Ref<HTMLLabelElement>;
}

const CheckboxWithControl: FC<Props> = ({
  id,
  label,
  control,
  name,
  required,
  requiredErrorMessage,
  style,
  className,
  errorWrapperStyle,
  errorFontColor,
  validationTargetRef,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: { value: required, message: requiredErrorMessage },
      }}
      render={({ field: { onChange, ...rest }, formState: { errors } }) => (
        <>
          <label
            ref={validationTargetRef}
            className={className}
            style={style}
            htmlFor={id}
          >
            <input {...rest} id={id} type="checkbox" onChange={onChange} />
            {label}
          </label>
          <ErrorMessage
            errors={errors}
            name={name as string}
            render={({ message }) => (
              <div style={errorWrapperStyle}>
                <CustomErrorMessage
                  error={"error"}
                  errorMessage={message}
                  errorFontColor={errorFontColor}
                />
              </div>
            )}
          />
        </>
      )}
    />
  );
};

export default CheckboxWithControl;
